import { InvoiceExportRepository } from "../../domain/repositories/InvoiceExportRepository";
import {
  InvoiceExportEntity,
  InvoiceExportParamsEntity,
} from "../../domain/entities/InvoiceExportEntity";
import { fetchInvoiceExportExcel } from "../api/invoiceExportsApi";

export class InvoiceExportRepositoryImpl implements InvoiceExportRepository {
  async downloadInvoiceExportExcel(
    params: InvoiceExportParamsEntity = {},
  ): Promise<InvoiceExportEntity> {
    const dto = await fetchInvoiceExportExcel({
      from_date: params.fromDate,
      to_date: params.toDate,
    });
    return {
      blob: dto.blob,
      filename: dto.filename,
    };
  }
}

